"use strict";

module.exports = function (config, get, post) {
	return {
		list: list,
		add: add,
		update: update,
		remove: remove,
		battery: battery
	};

	function list(){
		return get("/v2/devices/list");
	}

	function add(device){
		return post("/v2/devices/add", {
			device: device
		});
	}

	function remove(device){
		return post("/v2/devices/remove", {
			device: device
		});
	}

	function update(device){
		return post("/v2/devices/update", {
			device: device
		});
	}

	function battery(device, batteryLevel){
		return post("/v2/devices/battery", {
			device: device,
			battery: batteryLevel
		});
	}
};
